<template>
    <div id="app">
        <v-app id="inspire">
            <br><br><br>
            <v-card>
                <v-container grid-list>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-card color="blue-grey darken-3" dark>
                                <v-layout row>
                                    <v-flex xs4>
                                        <v-card-title primary-title>
                                            <div>
                                                <div class="display-1 font-weight-bold">{{selectedMotorcycle.model}}</div>
                                                <div class="title font-weight-medium">{{selectedMotorcycle.make}}</div>
                                                <div class="subheading font-weight-medium">{{selectedMotorcycle.yearModel}}</div><br>
                                                <div class="subheading font-weight-medium">{{selectedMotorcycle.odometer}} km</div>
                                                <div class="body font-weight-light">Last Service Mileage</div>
                                            </div>
                                        </v-card-title> 
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-card-title primary-title>
                                            <div>
                                                <div class="title font-weight-bold pt-1">{{selectedMotorcycle.color}}</div>
                                                <div class="body font-weight-light pb-2" >Color</div>
                                                <div class="title font-weight-bold">{{selectedMotorcycle.engineNumber}}</div>
                                                <div class="body font-weight-light pb-2" >Engine Number</div>
                                                <div class="title font-weight-bold">{{selectedMotorcycle.chassisNumber}}</div>
                                                <div class="body font-weight-light pb-2">Chassis Number</div>
                                                <div class="title font-weight-bold">{{selectedMotorcycle.plateNumber}}</div>
                                                <div class="body font-weight-light">Plate Number</div>
                                            </div>
                                        </v-card-title> 
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-card-title primary-title>
                                            <div>
                                                <div class="title font-weight-bold pt-1">{{selectedMotorcycle.classification}}</div>
                                                <div class="body font-weight-light pb-2" >Classification</div>
                                                <div class="title font-weight-bold">{{selectedMotorcycle.dateOfPurchase}}</div>
                                                <div class="body font-weight-light pb-2">Purchase Date</div>
                                                <div class="title font-weight-bold">{{selectedMotorcycle.registrationDate}}</div>
                                                <div class="body font-weight-light">Registration Date</div>
                                            </div>
                                        </v-card-title> 
                                    </v-flex>
                                </v-layout>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn dark color="deep-orange" outline @click="requestForChange(selectedMotorcycle)">UPDATE</v-btn>
                                    <v-btn dark color="deep-orange" @click="deleteMotorcycleRequest(selectedMotorcycle)">Delete</v-btn>
                                    <v-btn dark color="warning" @click="$router.push('/account')">Cancel</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout><br>

                    <v-layout>
                        <v-flex xs12 md12 style="overflow: auto">
                            <v-card-title primary-title class="headline blue-grey darken-3 font-weight-bold white--text"> SERVICE HISTORY
                            </v-card-title>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 v-if="serviceHistory.length > 0">
                            <v-timeline align-top dense>
                                <v-timeline-item  v-for="(list, index) in serviceHistory" :key="index" color="green darken-2" icon="check" small>
                                    <v-layout pt-3>
                                        <v-flex xs12>
                                            <strong>{{list.formatedDate}}</strong>
                                            <div v-for="(service, index2) in list.initialService" :key="index2">{{service.displayName}}</div>
                                            <div><strong>{{list.branch}}</strong></div>
                                            <div>{{list.mechanic}}</div>
                                        </v-flex>
                                    </v-layout>
                                </v-timeline-item>
                            </v-timeline>
                        </v-flex>

                        <v-flex xs12 v-else>
                            <div class="text-xs-center"> <br><br><br>
                                <v-card-title class="headline font-weight-bold justify-center">NO SERVICE HISTORY
                                </v-card-title>
                            </div>
                        </v-flex> 
                    </v-layout> 
                </v-container>
            </v-card>
            <v-dialog v-model="removeMotorcycleDialog" max-width="500px">
                <v-card>
                    <v-card-title class="title font-weight-regular">
                        Are you sure you want to remove this motorcycle in the list?
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-title class="subheading font-weight-regular justify-center">
                        You are about to remove the motorcycle details in the list.
                        <br>Do you want to proceed?
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-end">
                        <v-btn dark color="grey darken-1" @click="removeMotorcycleDialog=false">NO</v-btn>
                        <v-btn dark color="blue darken-4" @click="(deleteMotorCycle(forChangeMotorcycle))">YES</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <Snackbar v-model="snackbar.show" :type="snackbar.type" :message="snackbar.message" />
            <Progress v-model="progress.show" :message="progress.message" />
            <UpdateMcDialog v-model="updateMcDialog.show" :forChangeMotorcycle="selectedMotorcycle" />
        </v-app>
    </div>
</template>

<script>

import firebase from "firebase"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { mapGetters, mapActions, mapState } from "vuex"
import { db } from '../main.js'
import _ from 'lodash'
import Snackbar from './Snackbar.vue'
import Progress from './Progress.vue'
import UpdateMcDialog from './UpdateMcDialog.vue'
export default {
    components: {
        Snackbar,
        Progress,
        UpdateMcDialog
    },
    data() {
        return {
            routeModel: this.$route.params.model,
            motorcycles: [],
            headers: [
                { text: 'Dealer', sortable: false, value: 'dealer'},
                { text: 'Make', value: 'make',  sortable: false  },
                { text: 'Classification', value: 'classification',  sortable: false  },
                { text: 'Model', value: 'model',  sortable: false  },
                { text: 'Year', value: 'year',  sortable: false  },
                { text: 'Color', value: 'color',  sortable: false  },
                { text: 'Engine Number', value: 'engineNumber',  sortable: false  },
                { text: 'Chassis Number', value: 'chassisNumber',  sortable: false  },
                { text: 'Plate Number', value: 'plateNumber',  sortable: false  },
                { text: 'Mileage', value: 'odometer',  sortable: false  },
                { text: 'Date of Purchase', value: 'dateOfPurchase',  sortable: false  },
                { text: 'Registration Date', value: 'registrationDate',  sortable: false  },
                { text: 'More', value: 'name', align: 'center', sortable: false}
            ],
            customers: [],
            snackbar: {
                responseMessage: "",
                show: false,
                type: "success"
            },
            progress: {
                message: "",
                show: false,
            },
            removeMotorcycleDialog: false,
            motorcycleHistoryDialog: false,
            serviceHistory: [],
            selectedMotorcycle: {},
            forChangeMotorcycle: {},
            editMotorcyleDialog: false,
            updateMcDialog: {
                forChangeMotorcycle: {},
                show: false,
            },
        }
    },

    methods : {
        openMotorcycleDialog() {
            this.$store.dispatch("setMotorcycle", true)
            this.newMcProfileDialog = true
        },
        closeMotorcycleDialog() {
            this.$store.dispatch("setMotorcycle", false)
            this.newMcProfileDialog = false
        },
        showSnackbarMessage(message, success = true) {
            this.snackbar.type = success ? "success" : "error"
            this.snackbar.message = message
            this.snackbar.show = true
        },
        showProgress(message) {
            this.progress.message = message
            this.progress.show = true
        },
        stopProgress() {
            this.progress.show = false
        },
        showUpdateMcDialog(mcDetails) {
            this.updateMcDialog.show = true
            this.updateMcDialog.forChangeMotorcycle = mcDetails
        },

        deleteMotorcycleRequest(mc) {
            let self = this 
            db.collection("McDetails"+self.$stage)
            .where("email", "==", self.user.email)
            .where("model", "==", mc.model)
            .get().then(function(querySnapshot){
                if (querySnapshot.docs.length == 1) {
                    querySnapshot.forEach(function(doc) {
                        self.forChangeMotorcycle = doc.data()
                    })
                }
            }).then(function() {
                self.removeMotorcycleDialog = true
            }).catch(error => console.log(error))
        },

        deleteMotorCycle(mc) {
            let self = this
            
            db.collection("McDetails"+self.$stage).doc(mc.id)
            .update({
                "status": "0",
            }).then(function() {
                self.removeMotorcycleDialog = false
                self.$router.push('/account')
            }).catch(error => console.log(error))
        },

        viewHistory() {
            let self = this 
            self.serviceHistory = []
            db.collection("McDetails"+self.$stage)
            // .where("engineNumber", "==", mc.engineNumber)
            .where("email", "==", self.user.email)
            .where("model", "==", self.routeModel)
            .get().then(function(querySnapshot){
                if (querySnapshot.docs.length == 1) {
                    querySnapshot.forEach(function(doc) {
                        self.selectedMotorcycle = doc.data()
                    })
                }
            }).then(function() {
                self.motorcycleHistoryDialog = true
                if (self.selectedMotorcycle.transactions.length > 0) {
                    self.selectedMotorcycle.transactions.forEach(function(res) {
                        db.collection("ServiceBooking"+self.$stage).doc(res)
                        .get().then(function(services){
                            self.serviceHistory.push(services.data())
                        }).then(function(){
                            self.serviceHistory = (_.sortBy(self.serviceHistory, 'appointmentDate')).reverse()
                        })
                    })
                }
            }).catch(error => console.log(error))
        },

        requestForChange(mc) {
            let self = this
            self.showUpdateMcDialog(mc)
        },
    },

    mounted() {
        let self = this
        self.viewHistory()
    },

    computed : {
        ...mapGetters(["user"]),
        ...mapState(["Auth"])
    },

    watch: {
      
    }

}
</script>
